import commonEN from "./en/common"
import commonES from "./es/common"
import errorEN from "./en/error"
import errorES from "./es/error"
import authEN from "./en/auth"
import authES from "./es/auth"
import votesEN from "./en/votes"
import votesES from "./es/votes"
import blockchainEN from "./en/blockchain"
import blockchainES from "./es/blockchain"

export const es = {
  auth: authES,
  common: commonES,
  error: errorES,
  votes: votesES,
  blockchain: blockchainES,
}

export const en = {
  auth: authEN,
  common: commonEN,
  error: errorEN,
  votes: votesEN,
  blockchain: blockchainEN,
}
